/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProjectGroupWithDetails } from './projectGroup.d';

export interface IProjectGroupState {
  currentGroup: IProjectGroupWithDetails | null;
  groupsList: IProjectGroupWithDetails[];
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  selectedProjectIds: string[];
}

const initialState: IProjectGroupState = {
  currentGroup: null,
  groupsList: [],
  isLoading: false,
  isError: false,
  error: null,
  selectedProjectIds: [],
};

const projectGroupSlice = createSlice({
  name: 'projectGroup',
  initialState,
  reducers: {
    setCurrentGroup: (
      state,
      action: PayloadAction<IProjectGroupWithDetails | null>
    ) => {
      state.currentGroup = action.payload;
    },
    setGroupsList: (
      state,
      action: PayloadAction<IProjectGroupWithDetails[]>
    ) => {
      state.groupsList = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.isError = !!action.payload;
      state.error = action.payload;
    },
    resetProjectGroupState: (state) => {
      state.currentGroup = initialState.currentGroup;
      state.groupsList = initialState.groupsList;
      state.isLoading = initialState.isLoading;
      state.isError = initialState.isError;
      state.error = initialState.error;
      state.selectedProjectIds = initialState.selectedProjectIds;
    },
    toggleProjectSelection: (state, action: PayloadAction<string>) => {
      const projectId = action.payload;
      const index = state.selectedProjectIds.indexOf(projectId);
      if (index === -1) {
        state.selectedProjectIds.push(projectId);
      } else {
        state.selectedProjectIds.splice(index, 1);
      }
    },
    setSelectedProjects: (state, action: PayloadAction<string[]>) => {
      state.selectedProjectIds = action.payload;
    },
    clearSelectedProjects: (state) => {
      state.selectedProjectIds = [];
    },
  },
});

export const {
  setCurrentGroup,
  setGroupsList,
  setLoading,
  setError,
  resetProjectGroupState,
  toggleProjectSelection,
  setSelectedProjects,
  clearSelectedProjects,
} = projectGroupSlice.actions;

export default projectGroupSlice.reducer;

// Selectors
export const selectSelectedProjectIds = (state: {
  projectGroup: IProjectGroupState;
}) => state.projectGroup.selectedProjectIds;
